import React from "react";

import {
  Pill,
  QueueList,
  QueueRow,
  QueueRowMeta,
  QueueRowSymbol,
} from "../../styles";
import { ListEmpty } from "../styles";
import { WorkItemListProps } from "../types";

export const WorkItemList: React.FC<WorkItemListProps> = ({
  items,
  selectedKey,
  disabled,
  listRef,
  onSelect,
}) => {
  const rows = items.map((item) => ({
    ...item,
    isSelected: item.key === selectedKey,
    isResolved: item.status === "resolved",
    isDeferred: item.status === "deferred",
    handleClick: (event: React.MouseEvent<HTMLButtonElement>) =>
      onSelect(item.key, event),
  }));

  return (
    <div>
      <QueueList ref={listRef} aria-label="Work items">
        {rows.map(
          ({
            key,
            symbol,
            subtitle,
            meta,
            isSelected,
            isResolved,
            isDeferred,
            handleClick,
          }) => (
            <li key={key}>
              <QueueRow
                type="button"
                $isSelected={isSelected}
                aria-pressed={isSelected}
                disabled={disabled}
                onClick={handleClick}
              >
                <QueueRowSymbol>{symbol}</QueueRowSymbol>
                <QueueRowMeta>{subtitle}</QueueRowMeta>
                <QueueRowMeta>{meta}</QueueRowMeta>
                {isResolved && <Pill $tone="healthy">Resolved</Pill>}
                {isDeferred && <Pill $tone="unknown">Deferred</Pill>}
              </QueueRow>
            </li>
          ),
        )}
      </QueueList>
      {rows.length === 0 && <ListEmpty>No other items in this view.</ListEmpty>}
    </div>
  );
};
